import _styled from "styled-components";
const _excluded = ["className", "style", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { useTranslation } from '../../i18n';
const NoAutocompleteResults = _ref => {
  let {
      className,
      style,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const text = React.Children.toArray(children).length > 0 ? children : t('NO_RESULTS');
  return /*#__PURE__*/React.createElement(_StyledP, _extends({
    "data-testid": "Dropdown__noResults",
    className: className
  }, props, {
    $_css: [{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      height: 32,
      color: theme.tokens.colors.text.secondary.value
    }, theme.typography.bodySmall, style]
  }), text);
};
NoAutocompleteResults.displayName = 'NoAutocompleteResults';
NoAutocompleteResults.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Override for no results content */
  children: PropTypes.any
};
export default NoAutocompleteResults;
var _StyledP = _styled("p").withConfig({
  displayName: "NoAutocompleteResults___StyledP",
  componentId: "sc-sw3eng-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=NoAutocompleteResults.js.map